import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";

const ScorePercentageGraph = ({
  scoreType,
  startScore,
  endScore,
  boxColumn,
  fieldId,
  handleRangeScoreChange,
  scoreValue,
  scoreReset,
  dataEntryType,
  disabled
}) => {
  const [percentage, setPercentage] = useState("");
  const numbers = Array.from(
    { length: Number(endScore || 0) - Number(startScore || 0) },
    (_, i) => i + 1
  );

  const handleClick = (value) => {
    setPercentage(value - 1);
    if (!dataEntryType && !disabled) {
      handleRangeScoreChange(fieldId, "score", "value", value - 1)
    }
  };

  useEffect(() => {
    setPercentage(scoreValue ? Number(scoreValue) : "")
  }, []);

  return (
    <div className="hstack">
      <div className="d-flex gap-2 mt-2">
        {startScore === 0 && (
          <div
            onClick={() => { if (!dataEntryType && !disabled) handleRangeScoreChange(fieldId, "score", "value", 0); setPercentage(0) }}
            style={{
              width: 30,
              height: 30,
              display: "flex",
              fontSize: 12,
              opacity: disabled ? ".7" : "1",
              alignItems: "center",
              color: "#a2a1a1",
              justifyContent: "center",
              borderRadius: "15%",
              cursor: disabled ? "not-allowed" : "pointer",
              pointerEvents: disabled ? "none" : "auto",
              color: "#333",
              fontWeight: "bold",
              transition: "all 0.3s ease",
              background: "rgb(224, 224, 224)",
            }}
          >
            0{scoreType === "percentage" && "%"}
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {Array.from(
            { length: Math.ceil(numbers.length / Number(boxColumn || 5)) },
            (_, colIndex) => (
              <div
                key={colIndex}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                {numbers
                  .slice(
                    colIndex * Number(boxColumn || 5),
                    colIndex * Number(boxColumn || 5) + Number(boxColumn || 5)
                  )
                  ?.map((num) => (
                    <div
                      key={num}
                      onClick={() => { if (!disabled) handleClick(num + 1) }}
                      style={{
                        width: 30,
                        height: 30,
                        display: "flex",
                        fontSize: 12,
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "15%",
                        cursor: disabled ? "not-allowed" : "pointer",
                        pointerEvents: disabled ? "none" : "auto",
                        opacity: disabled ? ".7" : "1",
                        color: "#a2a1a1",
                        background:
                          percentage + 1 === (num + 1)
                            ? `conic-gradient(#adbcc8 ${(num + 1) * 3.6
                            }deg, #e0e0e0 ${(num + 1) * 3.6}deg 360deg)`
                            : "#e0e0e0",
                        color: "#333",
                        fontWeight: "bold",
                        boxShadow:
                          percentage + 1 === (num + 1)
                            ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                            : "none",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {(Number(startScore) || 0) + (num)}
                      {scoreType === "percentage" && "%"}
                    </div>
                  ))}
              </div>
            )
          )}
        </div>
      </div>
      {(percentage || percentage === 0) && (
        <div className="hstack justify-content-center w-100 flex-column">
          <div
            style={{
              position: "relative",
              width: 180,
              height: 180,
              borderRadius: "15%",
              background: `conic-gradient(#103c5e ${percentage * 3.6
                }deg, #adbcc8 ${percentage * 3.6}deg 360deg)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                width: 120,
                height: 120,
                borderRadius: "15%",
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  fontSize: 24,
                  fontWeight: "bold",
                  color: "##ffffffe6",
                }}
              >
                {percentage}
                {scoreType === "percentage" && "%"}
              </span>
            </div>
          </div>
          {(scoreReset || !disabled) &&
            <div
              className="text-capitalize mt-1 actionBtn"
              style={{ fontSize: 12, fontWeight: 800, marginTop: -4 }}>
              <Badge bg="danger"
                onClick={() => { if (!dataEntryType || !disabled) handleRangeScoreChange(fieldId, "", "value", ""); setPercentage("") }}
                className="CP" style={{ borderRadius: 3 }}>
                Reset
              </Badge>
            </div>
          }
        </div>
      )}

    </div>
  );
};

export default ScorePercentageGraph;
